import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FeedIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M20 1H4C2.3457 1 1 2.3457 1 4V24L6.33301 20H20C21.6543 20 23 18.6543 23 17V4C23 2.3457 21.6543 1 20 1ZM21 17C21 17.5518 20.5518 18 20 18H5.66699L3 20V4C3 3.44824 3.44824 3 4 3H20C20.5518 3 21 3.44824 21 4V17ZM13 7H19V9H13V7ZM13 11H17V13H13V11ZM6 7H10V13H6V7Z",
    fill: "currentColor"
  }));
}